export default __webpack_public_path__ + "static/media/logo-nurset.f4e1c927.svg";